export const CSV_DEFAULT_DELIMITER = '^';
export const CSV_DEFAULT_EMPTY_VALUE = '_NONE_';
export const CSV_BLOB_TYPE = 'text/csv;charset=utf-8';
export const CSV_ESCAPED_DOUBLE_QUOTE_PATTERN = /""/g;
export const CSV_SURROUNDING_QUOTE_PATTERN = /^"|"$/g;
export const CSV_QUOTE_CHARACTER = '"';

export const createCsvBlob = (content: string) => new Blob([content], { type: CSV_BLOB_TYPE });
